"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * @export
 * @enum {string}
 */
var AuditLogEntryType;
(function (AuditLogEntryType) {
    AuditLogEntryType["VIEWREPLY"] = "VIEW_REPLY";
    AuditLogEntryType["LISTREPLY"] = "LIST_REPLY";
    AuditLogEntryType["MODIFYREPLY"] = "MODIFY_REPLY";
    AuditLogEntryType["DELETEREPLY"] = "DELETE_REPLY";
    AuditLogEntryType["CREATEREPLY"] = "CREATE_REPLY";
    AuditLogEntryType["VIEWREPLYATTACHMENT"] = "VIEW_REPLY_ATTACHMENT";
    AuditLogEntryType["DOWNLOADREPLYATTACHMENT"] = "DOWNLOAD_REPLY_ATTACHMENT";
    AuditLogEntryType["EXPORTREPLYPDF"] = "EXPORT_REPLY_PDF";
    AuditLogEntryType["EXPORTREPLYXLSX"] = "EXPORT_REPLY_XLSX";
})(AuditLogEntryType = exports.AuditLogEntryType || (exports.AuditLogEntryType = {}));
function AuditLogEntryTypeFromJSON(json) {
    return AuditLogEntryTypeFromJSONTyped(json, false);
}
exports.AuditLogEntryTypeFromJSON = AuditLogEntryTypeFromJSON;
function AuditLogEntryTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AuditLogEntryTypeFromJSONTyped = AuditLogEntryTypeFromJSONTyped;
function AuditLogEntryTypeToJSON(value) {
    return value;
}
exports.AuditLogEntryTypeToJSON = AuditLogEntryTypeToJSON;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXVkaXRMb2dFbnRyeVR5cGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvZ2VuZXJhdGVkL2NsaWVudC9tb2RlbHMvQXVkaXRMb2dFbnRyeVR5cGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLG9CQUFvQjtBQUNwQixvQkFBb0I7QUFDcEI7Ozs7Ozs7Ozs7R0FVRzs7QUFFSDs7OztHQUlHO0FBQ0gsSUFBWSxpQkFVWDtBQVZELFdBQVksaUJBQWlCO0lBQ3pCLDZDQUF3QixDQUFBO0lBQ3hCLDZDQUF3QixDQUFBO0lBQ3hCLGlEQUE0QixDQUFBO0lBQzVCLGlEQUE0QixDQUFBO0lBQzVCLGlEQUE0QixDQUFBO0lBQzVCLGtFQUE2QyxDQUFBO0lBQzdDLDBFQUFxRCxDQUFBO0lBQ3JELHdEQUFtQyxDQUFBO0lBQ25DLDBEQUFxQyxDQUFBO0FBQ3pDLENBQUMsRUFWVyxpQkFBaUIsR0FBakIseUJBQWlCLEtBQWpCLHlCQUFpQixRQVU1QjtBQUVELFNBQWdCLHlCQUF5QixDQUFDLElBQVM7SUFDL0MsT0FBTyw4QkFBOEIsQ0FBQyxJQUFJLEVBQUUsS0FBSyxDQUFDLENBQUM7QUFDdkQsQ0FBQztBQUZELDhEQUVDO0FBRUQsU0FBZ0IsOEJBQThCLENBQUMsSUFBUyxFQUFFLG1CQUE0QjtJQUNsRixPQUFPLElBQXlCLENBQUM7QUFDckMsQ0FBQztBQUZELHdFQUVDO0FBRUQsU0FBZ0IsdUJBQXVCLENBQUMsS0FBZ0M7SUFDcEUsT0FBTyxLQUFZLENBQUM7QUFDeEIsQ0FBQztBQUZELDBEQUVDIn0=